import React, { useCallback, useMemo, useState } from 'react';
import { useStoreContext } from '../../../../store/context';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { TableHead } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useAddAlert, useFSMapCategory, useFSMapFuel, useFSMapSubCat, useFSMapMethod, useFSMapEndDate, useFSMapStartDate } from 'src/store/actions';
import { getHeader } from 'src/apis/getFuelSampleCalls';
import { buildPath, errorResponse } from 'src/store/common';
import { alertMessages } from 'src/constants';
import moment from "moment-timezone";
import Paper from '@mui/material/Paper';
import { useHistory } from 'react-router';
import './Site.scss';
type FuelsForSiteProps = {
  id: any;
}

export const FuelsForSite: React.FC<FuelsForSiteProps> = ({
  id
}) =>{
  const [state, dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);
  const [fuels, setFuels] = useState<any[]|null>(null);
  const setFSMapCatgory = useFSMapCategory(dispatch);
  const setFSMapFuel = useFSMapFuel(dispatch);
  const setFSMapSubCat = useFSMapSubCat(dispatch);
  const setFSMapMethod = useFSMapMethod(dispatch);
  const setFSEndDate = useFSMapEndDate(dispatch);
  const setFSStartDate = useFSMapStartDate(dispatch);

  const history = useHistory();

  const fuelSampleResponse = useCallback((request: any) =>{
    (async()=>{
      try{
        const returnFromPromise:any = await getHeader(null, addAlert, request);
        const method = state.fsMapMethod.code_key === 'None'? null: state.fsMapMethod.code_key;
        const subCat = state.fsMapSubCat.code_key === 'None'? null: state.fsMapSubCat.code_key;
        const fuelType = state.fsMapFuel?.fuel_type? state.fsMapFuel.fuel_type:null;
        const cat = state.fsMapCategory? state.fsMapCategory: null;

        if(returnFromPromise){
          const fuelsWithSelection = returnFromPromise.map((fuel)=> {
            if(fuel.fuel_type === fuelType && fuel.category === cat && fuel.sub_category===subCat && fuel.method===method){
              return{
                ...fuel,
                selected: true,
              }
            }
            else{
              return{
                ...fuel,
                selected: false
              }
            }

          })
          const fuelSorted = fuelsWithSelection.sort(function(a,b){
            return a.fuel_type.localeCompare(b.fuel_type);
          })      
          setFuels(fuelSorted)
        }
        else{
            setFuels([])
        }
      }
      catch(error){
        setFuels([])
        errorResponse(error, addAlert, alertMessages.fieldSampleHomeData);
        console.log('error', error)
      } 
    })();
  },[addAlert, state.fsMapMethod, state.fsMapSubCat, state.fsMapFuel, state.fsMapCategory]);

  useMemo(()=>{
    if(id){
        const requestVariable ={
            startDate: null,
            endDate: null,
            type: "All",
            status: "Submitted",
            category: "All",
            subCategory:"All",
            method: "All",
            id: id,
            sortBy: 'fuel_type',
            sortOrder: 'asc',
            fromAddSample: false,

        }
        fuelSampleResponse(requestVariable);
    }
    
  },[id, fuelSampleResponse
  ]);

  const clickFuelRow = (e: any)=>{
    const fuelSplit = e.target.id.split('|');
    const fuelType = fuelSplit[0];
    const cat = fuelSplit[1];
    const sub = fuelSplit[2]==='null'? null: fuelSplit[2];
    const methodRow = fuelSplit[3] ==='null'? null : fuelSplit[3];
    const newEnd = fuelSplit[4];

    const foundFuel = state.fuelList?.find((fuel)=>fuel.fuel_type ===fuelType);
    const foundSub = state.subCatList?.find((subC)=> sub===null? subC.code_key === 'None':subC.code_key === sub );
    const foundMethod = state.methodList?.find((method)=> methodRow===null? method.code_key === 'None':method.code_key === methodRow);

    setFSMapCatgory(foundFuel.category);
    setFSMapFuel(foundFuel);
    setFSMapSubCat(foundSub);
    setFSMapMethod(foundMethod);
    setFSEndDate(moment().year(moment(newEnd).year()).endOf('year').toISOString());
    setFSStartDate(moment().year(moment(newEnd).year()).startOf('year').toISOString())

    if(fuels){
      const newFuelList = fuels.map((fuel)=>{
        if(fuel.fuel_type === fuelType && fuel.category === cat && fuel.sub_category===sub && fuel.method===methodRow){
          return{
            ...fuel,
            selected: true,
          }
        }
        else{
          return{
            ...fuel,
            selected:false,
          };
        }
      });
      setFuels(newFuelList);
      const paramsForBuildPath = {
        dataType: state.mapDataType,
        radio: foundFuel.category,
        element: foundFuel.fuel_type,
        zoom: state.currentZoom,
        basemap: state.selectedBaseMap.id,
        minElevation: state.elevationFilterValues[0],
        maxElevation: state.elevationFilterValues[1],
        windOrMethod: foundMethod.code_key,
        windOrSub: foundSub.code_key
    }
    buildPath(paramsForBuildPath, history);
    }
  }

  return(
    <div style={{paddingBottom: 15}}>
        <TableContainer component={Paper} style={{ maxHeight: 150, maxWidth: 525 }} className="smooth-scrollbar">
            <Table style={{ tableLayout: "auto" }} >
                <TableHead style={{ height: '0px', position: 'sticky', zIndex: 100, left: 0 }}>
                    <TableRow>
                        <TableCell tabIndex={0} style={{ padding: 0, fontWeight: 700, fontSize: '12px', position: 'sticky', zIndex: 50, top: 0, backgroundColor: '#ececec', width: '75px', textAlign: 'center'}}>
                            FUEL
                        </TableCell>
                        <TableCell tabIndex={0} style={{ padding: 0, fontWeight: 700, fontSize: '12px', position: 'sticky', zIndex: 50, top: 0, backgroundColor: '#ececec', width: '65px',textAlign: 'center' }}>
                            METHOD
                        </TableCell>
                        <TableCell tabIndex={0} style={{ padding: 0, fontWeight: 700, fontSize: '12px', position: 'sticky', zIndex: 50, top: 0, backgroundColor: '#ececec', width: '80px',textAlign: 'center' }}>
                            SUB-CATEGORY
                        </TableCell>
                        <TableCell tabIndex={0} style={{ padding: 0,fontWeight: 700, fontSize: '12px', position: 'sticky', zIndex: 50, top: 0, backgroundColor: '#ececec', width: '80px',textAlign: 'center' }}>
                            LATEST SAMPLE
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        fuels?.map((sample:any)=>(
                            <TableRow 
                              tabIndex={0}
                              className={(!state.user? (sample.selected?'notSignedInStyle selectionStyle':'notSignedInStyle'):(sample.selected?'signedInStyle selectionStyle': 'signedInStyle'))}
                              key={`${sample.fuel_type}|${sample.category}|${sample.sub_category}|${sample.method}|${sample.latestSampleDate}`}
                              id={`${sample.fuel_type}|${sample.category}|${sample.sub_category}|${sample.method}|${sample.latestSampleDate}`}
                              hover={state.user}
                              selected={sample.selected}
                              onClick={(e)=>state.user && clickFuelRow(e)}        
                              onKeyDown={(event) => { event.key==='Enter' && state.user && clickFuelRow(event)}}
                            >
                                <TableCell tabIndex={0} style={{ textAlign:'left', fontSize: '12px', padding: 1, paddingLeft: '2px'}} id={`${sample.fuel_type}|${sample.category}|${sample.sub_category}|${sample.method}|${sample.latestSampleDate}`}>{sample.fuel_type}</TableCell>
                                <TableCell tabIndex={0} style={{ textAlign:'center', fontSize: '12px', padding: 1}} id={`${sample.fuel_type}|${sample.category}|${sample.sub_category}|${sample.method}|${sample.latestSampleDate}`}>{sample.method}</TableCell>
                                <TableCell tabIndex={0} style={{ textAlign:'center', fontSize: '12px', padding: 1}} id={`${sample.fuel_type}|${sample.category}|${sample.sub_category}|${sample.method}|${sample.latestSampleDate}`}>{sample.sub_category}</TableCell>
                                {
                                  (moment(sample.latestSampleDate).utc() <= moment(state.fsMapEndDate).utc()) && (moment(sample.latestSampleDate).utc() >= moment(state.fsMapStartDate).utc()) ? (
                                    <Tooltip title="In Date Range" placement="right-start" PopperProps={{style:{zIndex:100000}}}>
                                    <TableCell tabIndex={0} style={{ textAlign:'center', fontSize: '12px', fontWeight:700, padding: 1}} id={`${sample.fuel_type}|${sample.category}|${sample.sub_category}|${sample.method}|${sample.latestSampleDate}`}>
                                      {moment(sample.latestSampleDate).tz(state.userTimeZone.id[0]).format('MM/DD/YY')}
                                    </TableCell>
                                    </Tooltip>
                                  ):
                                  (
                                    <Tooltip title="Out of Date Range" placement="right-end" PopperProps={{style:{zIndex:100000}}}>
                                    <TableCell tabIndex={0} style={{ textAlign:'center', fontSize: '12px', padding: 1}} id={`${sample.fuel_type}|${sample.category}|${sample.sub_category}|${sample.method}|${sample.latestSampleDate}`}>
                                      {moment(sample.latestSampleDate).tz(state.userTimeZone.id[0]).format('MM/DD/YY')}
                                    </TableCell>
                                  </Tooltip>
                                  )
                                }
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </div>
  )
  }
